import { sleep } from '@ipfabric/ui-components/utils/sleep';
import type { MultiplesGeneratorCommandFactory } from '../MultiplesGeneratorModel';
import { generateMultiplier } from './generateMultiplier';

interface GenerateMultiplierWithDelayCommand {
  timeout: number;
}

const DEFAULT_DELAY = 1000;

/**
 * Example of a command model command that receives an (optional) argument
 * and calls another command
 *
 * More details of how the commands work are documented in `useCommandDispatcher`'s doc.
 *
 * @see useCommandDispatcher
 */
export const generateMultiplierWithDelay: MultiplesGeneratorCommandFactory<
  // adding `| undefined` to the generic argument indicates that the command argument is optional.
  GenerateMultiplierWithDelayCommand | undefined
> = (_cmdContext, dispatch) => async (command) => {
  await sleep(command?.timeout ?? DEFAULT_DELAY);
  dispatch(generateMultiplier);
};
